import React from 'react'

const NotesContactWizard = ({ formik }: any) => {
    return (
        <div className='row'>
            <h5 className='mt-2 mb-2'>Comments</h5>
            <div className="col-md-12 mt-2">
                <div className='col-md-12'>
                    <label>Internal Comments <span className='text-danger'>*</span></label>
                    <textarea
                        className='form-control'
                        rows={5}
                        style={{ width: '100%' }}
                        value={formik?.values?.internalComments}
                        onChange={(e: any) => formik.setFieldValue('internalComments', e?.target?.value)}
                    />
                </div>
            </div>
            <div className="col-md-12 mt-2">
                <div className='col-md-12'>
                    <label>External Comments</label>
                    <textarea
                        className='form-control'
                        rows={5}
                        style={{ width: '100%' }}
                        value={formik?.values?.externalComments}

                        onChange={(e: any) => formik.setFieldValue('externalComments', e?.target?.value)}
                    />
                </div>
            </div>
        </div>
    )
}

export default NotesContactWizard